<ng-container *ngIf="!isLeftMenuMessageNotification">
  <div
    #messagesTooltip="kendoTooltip"
    kendoTooltip
    [tooltipTemplate]="tooltipTemplate"
    tooltipClass="messages-notifications-tooltip"
    filter="div"
    position="bottom"
    showOn="none"
    [boiPermissionChecker]="[userPermissions.ViewCase]"
  >
    <div
      #anchor
      class="vo-icon vo-dark-icon-message vo-icon--24 mr-15 cursor-pointer position-relative"
      (click)="toggle(messagesTooltip, anchor, $event)"
    >
      <span class="message-count message-count--position" *ngIf="alertedCasesCount$ | async as alertsCount">
        {{ alertsCount }}</span
      >
    </div>
  </div>

  <ng-template #tooltipTemplate>
    <ng-container *ngFor="let message of unreadMessages">
      <div
        class="d-flex justify-content-between p-10 cursor-pointer message-item"
        *ngIf="message.CaseType === referenceDataOptionLists.CaseTypeCustomerMortgageAccountOption"
        (click)="goToCaseMessages(message.SamID, messagesTooltip)"
      >
        <div class="vo-link flex-1 text-center text-md-left">
          {{ message.SamID }}
        </div>
        <span class="message-item__count"> {{ message.AlertsCount }} </span>
      </div>

      <div
        class="d-flex justify-content-between p-10 cursor-pointer message-item"
        *ngIf="message.CaseType !== referenceDataOptionLists.CaseTypeCustomerMortgageAccountOption"
        (click)="goToCaseMessages(message.CaseIDHash, messagesTooltip)"
      >
        <div class="vo-link flex-1 text-center text-md-left">
          {{ message.CaseID }}
        </div>
        <span class="message-item__count"> {{ message.AlertsCount }} </span>
      </div>
    </ng-container>

    <a
      class="vo-link d-inline-block p-10"
      *ngIf="canViewAlertedCases && unreadMessages.length > 0"
      [innerHTML]="referenceDataLabels.SeeAllCasesWithNotifications | localizeLabel"
      (click)="showOnlyAlertedCases(messagesTooltip)"
    ></a>

    <div
      *ngIf="unreadMessages.length === 0"
      class="vo-body-regular-14 p-10"
      [innerHTML]="referenceDataLabels.NoCaseNotifications | localizeLabel"
    ></div>
  </ng-template>
</ng-container>

<ng-container *ngIf="isLeftMenuMessageNotification && unreadMessages.length > 0">
  <div
    class="vo-left-mobile-menu__item px-30 py-15 d-flex justify-content-between align-items-center"
    [class.vo-left-mobile-menu__message--opened]="isLeftMenuMessageOpened"
    [class.vo-left-mobile-menu__message--closed]="!isLeftMenuMessageOpened"
    (click)="toogleLeftMsgMenu()"
  >
    <span>
      <span>{{ referenceDataLabels.DirectCustomerMyMortgageHubMessages | localizeLabel }}</span>
      <span class="vo-left-mobile-menu__item-message-count d-inline-block ml-10">{{ unreadMessages.length }}</span>
    </span>
    <span class="vo-icon vo-icon--24 d-inline-block"></span>
  </div>

  <ng-container *ngFor="let message of unreadMessages">
    <div class="vo-left-menu__message-item-bg">
      <div
        class="vo-left-mobile-menu__item px-45 py-10 d-flex align-items-center"
        [class.vo-left-mobile-menu__message--opened]="selectedCaseHash === message.SamID"
        *ngIf="
          isLeftMenuMessageOpened && message.CaseType === referenceDataOptionLists.CaseTypeCustomerMortgageAccountOption
        "
        (click)="goToCaseMessages(message.SamID, messagesTooltip)"
      >
        <span>{{ message.SamID }}</span>
        <span class="vo-left-mobile-menu__item-message-count d-inline-block ml-10"> {{ message.AlertsCount }} </span>
      </div>

      <div
        class="vo-left-mobile-menu__item px-45 py-10 d-flex align-items-center"
        [class.vo-left-mobile-menu__message--opened]="selectedCaseHash === message.CaseIDHash"
        *ngIf="
          isLeftMenuMessageOpened && message.CaseType !== referenceDataOptionLists.CaseTypeCustomerMortgageAccountOption
        "
        (click)="goToCaseMessages(message.CaseIDHash, messagesTooltip)"
      >
        <span>{{ message.CaseID }}</span>
        <span class="vo-left-mobile-menu__item-message-count d-inline-block ml-10"> {{ message.AlertsCount }} </span>
      </div>
    </div>
  </ng-container>
</ng-container>
